module.exports = __webpack_public_path__ + "static/img/c1.2416be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh/c1.png
// module id = WXPv
// module chunks = 0